/** @jsx h */
import { h } from 'preact'
import { useRef, useState } from 'preact/hooks'

import Results from './Results'
import Attribution from './Attribution'
import * as analytics from '../../../../utils/analytics'
import t from '../../../../utils/translate'

const Lookup = ({ url, proofPointName, eventLabel }) => {
  if (url === null) {
    return
  }

  const postcode = useRef(null)
  const [results, setResults] = useState({})

  const track = () => {
    analytics.track('recycling_lookup', {
      eventAction: proofPointName,
      eventLabel
    })
    analytics.track('recycling_lookup', {
      object: 'recycling',
      action: 'lookup',
      subject_name: proofPointName,
      event_label: eventLabel
    }, { adapter: 'segment' })
  }

  const constructUrl = () => {
    const formattedPostcode = postcode.current.value.toUpperCase().replace(/\s+/g, '')
    return `${url}?postcode=${formattedPostcode}`
  }

  const fetchResults = async e => {
    e.preventDefault()

    track()

    fetch(constructUrl())
      .then((response) => {
        return response.json()
      })
      .then((parsed) => {
        setResults(parsed)
      })
      .catch((_) => {
        setResults({ error: true })
      })
  }

  return (
    <section class='ModalCard-section'>
      <h3 class='ModalCard-heading'>
        {t('proof_points.js.recycling.header')}
      </h3>
      <p class='ModalCard-para u-marginTop8'>
        {t('proof_points.js.recycling.cta')}
      </p>
      <form class='u-marginTop8' onSubmit={fetchResults} data-remote='true' method='get'>
        <input
          class='Form-control Form-control--light Form-control--search' ref={postcode} placeholder={t('proof_points.js.recycling.search.hint')}
          type='text' name='postcode'
        />
        <input
          type='submit' name='commit' value={t('proof_points.js.recycling.search.action')} className='Action Action--green60 u-marginTop8'
          data-disable-with={t('proof_points.js.recycling.search.action')}
        />
      </form>
      <Results {...results} />
      <Attribution />
    </section>
  )
}

export default Lookup
